import styled from 'styled-components';
import {transparentize} from 'polished';

export const Wrapper = styled.div`
    
`;

export const Blocks = styled.div`

`;

export const DueTime = styled.span`
  display: inline-block;
  box-sizing: border-box;
  padding: 6px 10px;
  border-radius: 5px;
  font-weight: 500;
  background: ${({theme}) => theme.colors.primary};
`;


export const Label = styled.span`
  margin-top: 10px; 
  margin-bottom: 20px;
  display: block;
  line-height: 18px;
  font-size: 14px;
  color: ${({theme}) => `
    ${transparentize(.6, theme.variables.color)};
  `};
`;
